import React from 'react'
import { Col, ConsoleCard, PageHeading, CardsRow, Page } from 'admin-web-ui'
import { DailySudoIdentitiesCreated, TotalSudosActive } from '../charts'

export const SudosDashboard: React.FC = () => {
  return (
    <Page>
      <PageHeading>Sudo Dashboard</PageHeading>
      <CardsRow>
        <Col span={24}>
          <ConsoleCard>
            <TotalSudosActive />
          </ConsoleCard>
        </Col>
      </CardsRow>
      <CardsRow>
        <Col span={24}>
          <ConsoleCard>
            <DailySudoIdentitiesCreated />
          </ConsoleCard>
        </Col>
      </CardsRow>
    </Page>
  )
}
